import { getPanelAccessesApi } from "../../../../services/newServices";
import panelAccessTypes from "../../../actionTypes/panelAccessTypes";

export const getPanelAccesses =
  ({ hotelId }) =>
  async (dispatch) => {
    const response = await getPanelAccessesApi({ hotelId });
    if (response.status !== 200) return;
    const accesssibleFeatures = response.data?.accesssibleFeatures || [];
    const restrictedFeatures = response.data?.restrictedFeatures || [];
    const payload = {
      accesssibleFeatures: new Set(accesssibleFeatures),
      restrictedFeatures: new Set(restrictedFeatures),
    };
    dispatch({ type: panelAccessTypes.SET_FEATURES, payload });
  };
